//flexsteel theme specific JS logic

const productContent = document.querySelector('.shopify-section--product-content .product-content');
if (productContent !== null) {

	const mainProduct = document.querySelector('.product__info .product-form');

	mainProduct.parentNode.insertBefore(productContent.cloneNode(true), mainProduct.nextSibling);
	productContent.style.display = 'none';

	//this is desktop tab opener
	const tabs = document.querySelectorAll('.tabs-nav__item-list');
	if (tabs.length > 0) {
		for (let i = 0; i < tabs.length; i++) {
			const tab = tabs[i];
			if (tab && tab.getAttribute('has-bss') === 'false') {
				const bssTab = tab.querySelector('.tabs-nav__item[tab-type="bss"]');
				if (bssTab) {
					bssTab.parentNode.removeChild(bssTab);
				}
			}
		}
	}

	const productTabs = document.querySelectorAll('.product-tabs__content');
	if (productTabs.length > 0) {
		productTabs.forEach((tabs) => {
			let hasBSS = tabs.getAttribute('has-bss');
			if(hasBSS == "false"){
				const tabItems = tabs.querySelectorAll('.product-tabs__tab-item-wrapper[tab-type="bss"]');
				if(tabItems.length > 0){
					tabItems.forEach((tab) => {
						tab.parentNode.removeChild(tab);
					});
				}
			}
		});
	}


}

const columnContainers = document.querySelectorAll('.column-container');
if (columnContainers.length > 0) {
	columnContainers.forEach((container, index) => {
		if (columnContainers[index + 1] === container.nextElementSibling) {
			const wrapper = document.createElement('div');
			wrapper.classList.add('column-container-wrapper');
			container.parentNode.insertBefore(wrapper, container);
			wrapper.appendChild(container);
			wrapper.appendChild(columnContainers[index + 1]);
		}
	});
}

const makeColDivs = document.querySelectorAll('[class*="make-col-"]');
if (makeColDivs.length > 0) {
	console.log(makeColDivs);
	makeColDivs.forEach((div) => {
		let section = div.closest('.shopify-section');
		[...div.classList].forEach((className) => {
			if (className.includes('make-col-')) {
				section.classList.add(className.replace('make-', ''));
			}
		});
	});
}


//if two adjacent .shopify-section divs have a col-md-* class wrap them in column-container-wrapper
const sectionDivs = document.querySelectorAll('.shopify-section');
if (sectionDivs.length > 0) {
	sectionDivs.forEach((div, index) => {
		if (sectionDivs[index + 1] === div.nextElementSibling && div.classList.contains('col-md-6') && sectionDivs[index + 1].classList.contains('col-md-6')) {
			const wrapper = document.createElement('div');
			wrapper.classList.add('column-container-wrapper');
			div.parentNode.insertBefore(wrapper, div);
			wrapper.appendChild(div);
			wrapper.appendChild(sectionDivs[index + 1]);
		}
	});
}

//Outdoor template
const links = document.querySelectorAll('.template-collection-outdoor .link');
if (links.length > 0) {
	links.forEach((link) => {
		if (link.href.includes('#explore-collection')) {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				document.querySelector('.template-collection-outdoor #main .shopify-section--image-with-text-overlay').scrollIntoView({ behavior: "smooth" });
			});
		}
	});
}


//image compare slider from old flexsteel.com
const sliders = document.querySelectorAll(".image-comparison-slider");
if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const sliderImgWrapper = slider.querySelector(".img-wrapper");
		const sliderHandle = slider.querySelector(".handle");

		slider.addEventListener("mousemove", sliderMouseMove);
		slider.addEventListener("touchmove", sliderMouseMove);

		function sliderMouseMove(event) {

			if (isSliderLocked) return;

			const sliderLeftX = slider.offsetLeft;
			const sliderWidth = slider.clientWidth;
			const sliderHandleWidth = sliderHandle.clientWidth;

			let mouseX = (event.clientX || event.touches[0].clientX) - sliderLeftX;
			if (mouseX < 0) mouseX = 0;
			else if (mouseX > sliderWidth) mouseX = sliderWidth;

			sliderImgWrapper.style.width = `${((1 - mouseX / sliderWidth) * 100).toFixed(4)}%`;
			sliderHandle.style.left = `calc(${((mouseX / sliderWidth) * 100).toFixed(4)}% - ${sliderHandleWidth / 2}px)`;
		}

		let isSliderLocked = false;

		slider.addEventListener("mousedown", sliderMouseDown);
		slider.addEventListener("touchstart", sliderMouseDown);
		slider.addEventListener("mouseup", sliderMouseUp);
		slider.addEventListener("touchend", sliderMouseUp);
		slider.addEventListener("mouseleave", sliderMouseLeave);

		function sliderMouseDown(event) {
			if (isSliderLocked) isSliderLocked = false;
			sliderMouseMove(event);
		}

		function sliderMouseUp() {
			if (!isSliderLocked) isSliderLocked = true;
		}

		function sliderMouseLeave() {
			if (isSliderLocked) isSliderLocked = false;
		}
	});
}


//Image grid block
const image_grid_items = document.querySelectorAll('.image-grid .has-modal');
if (image_grid_items.length > 0) {
	image_grid_items.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const modal = link.querySelector('.modal');
			modal.open = true;
			// modal.setAttribute("open", true);
		});
	});
}

const modal_links = document.querySelectorAll('a[href^="#"]');
modal_links.forEach((link) => {
	const modalId = new URL(link.href, window.location.href).hash.substring(1);
	//check if modal id exists in the page
	const modal = document.getElementById(modalId);
	if (modal !== null && modal.classList.contains('modal')){
		console.log(modalId);
		link.addEventListener('click', (e) => {
			e.preventDefault();
			modal.open = true;
		});
	}
});


document.addEventListener("DOMContentLoaded", () => {
/////////////////////////////////
// Toast Notification Functionality
/////////////////////////////////

const zeclinerBtn = document.getElementById('zecliner_btn');
const toast = document.getElementById('toast');
const acceptToastBtn = document.getElementById('accept_toast');
const declineToastBtn = document.getElementById('decline_toast');
const closeToastBtn = document.getElementById('close_toast');

if (zeclinerBtn && toast) {
    // Show toast on Zecliner button click
    zeclinerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        toast.classList.add('show');

        // Auto-close toast after 5 seconds
        setTimeout(() => {
            toast.classList.remove('show');
        }, 5000);
    });

    // Handle toast actions
    acceptToastBtn.addEventListener('click', () => {
        toast.classList.remove('show');
        window.open('https://zecliner.com/', '_blank');
    });

    declineToastBtn.addEventListener('click', () => {
        toast.classList.remove('show');
    });

    closeToastBtn.addEventListener('click', () => {
        toast.classList.remove('show');
    });

    // Close toast when clicking outside
    document.addEventListener('click', (event) => {
        if (!toast.contains(event.target) && !zeclinerBtn.contains(event.target)) {
            toast.classList.remove('show');
        }
    });
}

/////////////////////////////////
// Carousel Functionality
/////////////////////////////////

const carouselContainer = document.querySelector(".carousel-container");
const slides = document.querySelectorAll(".carousel-slide");
const indicators = document.querySelectorAll(".indicator");
const prevButton = document.querySelector(".carousel-nav.prev");
const nextButton = document.querySelector(".carousel-nav.next");

if (carouselContainer && slides.length > 0) {
	let currentSlide = 0;
	let autoPlayInterval;

	const updateCarousel = () => {
		carouselContainer.style.transform = `translateX(-${currentSlide * 100}%)`;
		indicators.forEach((indicator, index) => {
			indicator.classList.toggle("active", index === currentSlide);
		});
	};

	const nextSlide = () => {
		currentSlide = (currentSlide + 1) % slides.length;
		updateCarousel();
	};

	const prevSlide = () => {
		currentSlide = (currentSlide - 1 + slides.length) % slides.length;
		updateCarousel();
	};

	const startAutoPlay = () => {
		if (slides.length <= 1) return;
		clearInterval(autoPlayInterval);
		autoPlayInterval = setInterval(nextSlide, 5000);
	};

	const pauseAutoPlay = () => {
		clearInterval(autoPlayInterval);
	};

	indicators.forEach((indicator, index) => {
		indicator.addEventListener("click", () => {
			currentSlide = index;
			updateCarousel();
			pauseAutoPlay();
		});
	});

	if (prevButton && nextButton) {
		prevButton.addEventListener("click", () => {
			prevSlide();
			pauseAutoPlay();
		});
		nextButton.addEventListener("click", () => {
			nextSlide();
			pauseAutoPlay();
		});
	}

	startAutoPlay();
}

/////////////////////////////////
// Hotspot Functionality
/////////////////////////////////

const hotspots = document.querySelectorAll(".hotspot");

hotspots.forEach((hotspot) => {
    hotspot.addEventListener("click", (e) => {
        e.stopPropagation(); // Prevent event bubbling
        const content = hotspot.querySelector(".hotspot-content");
        content.style.opacity = content.style.opacity === "1" ? "0" : "1";
        content.style.visibility =
            content.style.visibility === "visible" ? "hidden" : "visible";
    });
});

// Close hotspot content when clicking outside
document.addEventListener("click", () => {
    hotspots.forEach((hotspot) => {
        const content = hotspot.querySelector(".hotspot-content");
        content.style.opacity = "0";
        content.style.visibility = "hidden";
    });
});
});



